import {
  Outlet,
  useLocation,
  useNavigate,
} from "react-router-dom";
import { Breadcrumb } from "../../../components/Breadcrumb";
import { Item } from "../../../types/item";
import {
  guardLoader,
  orderAheadOrdersGate,
} from "../../order-ahead/guards";
import {OrderAheadOrdersList} from "./OrderAheadOrdersList";
import {OrderAheadOrderShow, orderAheadOrderShowLoader} from "./OrderAheadOrderShow";

const OrderAheadOrdersIndex = () => {
  const location = useLocation();
  const navigate = useNavigate();

  if (location.pathname === "/order-ahead-orders") {
    navigate(`/order-ahead-orders/list`);
  }

  return (
    <>
      <Outlet />
    </>
  );
};

export const orderAheadOrdersRouter = {
  path: "/order-ahead-orders",
  id: "order-ahead-orders",
  element: <OrderAheadOrdersIndex />,
  // Without this the pages were reachable by URL for any signed-in dashboard
  // user; the sidebar link was all the permission controlled.
  loader: guardLoader(orderAheadOrdersGate),
  handle: {
    crumb: () => <Breadcrumb name="Order Ahead Orders" href="/order-ahead-orders/list" />,
  },
  children: [
    {
      path: "list",
      id: "order-ahead-orders-list",
      element: <OrderAheadOrdersList />,
    },
    {
      path: ":id",
      id: "order-ahead-orders-show",
      element: <OrderAheadOrderShow />,
      loader: guardLoader(orderAheadOrdersGate, orderAheadOrderShowLoader),
      handle: {
        crumb: (data: Item) => (
          <Breadcrumb
            name={`Show ${data.id}`}
            href={`/order-ahead-orders/${data.id}`}
          />
        ),
      },
    },
  ],
};
